module.exports = __webpack_public_path__ + "f792f9b71ac27a8c3634fa10cebc17dc.svg";